import React, { useEffect, useState } from 'react';
import UserTabs from './UserManagement/UserTabs';
import FacilityTabs from './FacilityManagement/FacilityTabs';
import BreadcrumbComponent from './../components/common/Breadcrumb';
import Navigation from '../components/common/Navigation';
import UserIcon from './../assets/svg_main/user.svg';
import HealthFacilityIcon from './../assets/svg_main/health-facility.svg';
import GeoNonGeoIcon from './../assets/svg_main/geo-nongeo.svg';
import ApprovalIcon from './../assets/svg_main/approval.svg';
import DownloadIcon from './../assets/svg/download-02.svg';
import './AppWrapperComponent.css';
import TabsComponent from '../components/common/TabsComponent';
import { setCurrentTab } from '@store/actions/zoneDetailsActions';
import { useDispatch } from 'react-redux';
import BeneficiariesTabs from './Beneficiary-block';

import {MenuPermission} from './../services/usePermission';
import { usePermissions } from './../context/PermissionsContext';
import ReferencesTabs from './References/ReferencesTabs';

interface AppWrapperComponentProps {
  page: string;
  tabs: any[];
  showGeoTab?: string;
  tabsPermision?: boolean;
}

// const getGeoNonGeoPath = (moduleCode: string): string => {
//   return moduleCode === 'GeoNG_HBSD' ? '/healthblock' : '/zone';
// };

// const getGeoNonGeoPath = (moduleCode: string): string => {
//   return moduleCode === 'GeoNG_HBSD' ? '/healthblock' : '/zone';
// };
const getGeoNonGeoPath = (moduleCode: string): string => {
  switch (moduleCode) {
    case 'GeoNG_HBSD':
      return '/healthblock';
    case 'GeoNG_ZDC':
      return '/zone';
    case 'GeoNG_vhnduhnd':
      return '/VHND';
    default:
      return '/zone';
  }
};

const navigationMenu = (permission:any) => {
  const isZoneAvail = Object.keys(permission).length > 0?permission.find((val:any) => val.module_code === "GeoNG_ZDC"):false;
  const isHBAvail = Object.keys(permission).length > 0?permission.find((val:any) => val.module_code === "GeoNG_HBSD"):false;
  const isVhndAvail = Object.keys(permission).length > 0?permission.find((val:any) => val.module_code === "GeoNG_VHNDUHND"):false;
  return [
    {
      name: 'User Management',
      module_code:'UserMgmt',
      routeName: 'User Management',
      icon: UserIcon,
      path: '/user-management',
    },
    {
      name: 'Geo / Non Geo Entity',
      module_code: (isHBAvail && isZoneAvail && isVhndAvail) || isZoneAvail  ? 'GeoNG_ZDC': isHBAvail ? 'GeoNG_HBSD' : isVhndAvail ? 'GeoNG_VHNDUHND' :'',
      routeName: 'Geographical Entities',
      icon: GeoNonGeoIcon,
      path: (isHBAvail && isZoneAvail && isVhndAvail) || isZoneAvail ? getGeoNonGeoPath('GeoNG_ZDC') : isVhndAvail ? getGeoNonGeoPath('GeoNG_vhnduhnd') : isHBAvail ? getGeoNonGeoPath('GeoNG_HBSD') : '',
    },
    {
      name: 'Health Facility',
      module_code:'FcltyMgmt',
      routeName: 'Health Facility',
      icon: HealthFacilityIcon,
      path: '/health-facility',
    },
    {
      name: 'Notifications',
      module_code:'Notifications',
      routeName: 'Notifications',
      icon: ApprovalIcon,
      path: '/notifications',
    },
    {
      name: 'Integrations',
      module_code:'Integrations',
      routeName: 'Integrations',
      icon: ApprovalIcon,
      path: '/integrations',
    },
    {
      name: 'References',
      module_code:'References',
      routeName: 'References',
      icon: DownloadIcon,
      path: '/references',
    }
  ];
}



// {"module_name":"All Users","module_code":"UserMgmt", "path":"/user-management"},
// {"module_name":"Roles","module_code":"UserMgmt_Roles", "path":"/user-management/role"},
// {"module_name":"Analytics","module_code":"UserMgmt_ANTS", "path":"/user-management/analytics"}
const PathList = [{"module_name":"Health Block /Sub Division","module_code":"GeoNG_HBSD", "path":"/healthblock"},
{"module_name":"Zone/Division/Circle","module_code":"GeoNG_ZDC", "path":"/zone"},
{"module_name":"VHND/UHND Outreach","module_code":"GeoNG_vhnduhnd", "path":"/VHND"}
]

const constructBreadCrumb = (props: any, tabState: string, tabs: any = []) => {
  const { page } = props;
  const currentTab = tabState ? tabState : tabs[0];
  return [
    { value: page, label: page === 'Beneficiaries' ? 'Service Provider' : page },
    { value: currentTab, label: currentTab },
  ];
};

const AppWrapperComponent = (props: AppWrapperComponentProps) => {
  const { page, tabs, tabsPermision } = props;
  const [tabsData, setTabsData]: any[] = useState([])
  const [currentRoute, setCurrentRoute] = useState('');
  const [tabState, setTabState] = useState<any>('');
  const dispatch = useDispatch();
  const { permissions } =  usePermissions();
  

  const handleTabsPermissions = (tabData:any) => {
    const result:any[] = [];
  
    tabData.forEach((element:any)=>{
        if(permissions.filter((ele:any)=>ele.module_code===element.module_code).length>0){
            result.push(element.module_name)
        }
    });
    setTabsData(result);
    !props.showGeoTab && setTabState(result[0]);
  };

  useEffect(() => {
    setCurrentRoute(props.page);
    if (tabsPermision && tabsPermision === true ) {
      handleTabsPermissions(tabs);
    } else {
      setTabsData(tabs);
      !props.showGeoTab && setTabState(props.tabs[0]);
    }
    
    // props.showGeoTab && setTabState(props.tabs.indexOf(tabState));
  }, [props]);

  useEffect(() => {
    dispatch(setCurrentTab(tabState));
  }, [tabState])


  const breadcrumbOptions = constructBreadCrumb(props, tabState, tabsData);
  const tabNumber = (tab: string | undefined) => {
    let number = 0;
    if(tabsData.length===1){
      return 0;
    }
    else{
    switch (tab) {
      case 'VHND':
        number = (tabsData.length === 3) ? 1 : 0;
        break;
      case 'healthblock':
        number = (tabsData.length === 3) ? 2 : 1;
        break;
      default:
        break;
    }
    return number;
  }
  };

  const tabUserMgmtNumber = (tab: string | undefined) => {
    let number = 0;
    switch (tab) {
      case 'analytics':
        number = 2;
        break;
      case 'role':
        number = 1;
        break;
      default:
        break;
    }
    return number;
  }





// const choosePathforTab = (moduleName:String) => {
//   const pathItem = PathList.find(item => item.module_name === moduleName);
//   return pathItem ? pathItem.path : ''; 
// };
// 
// 


// const navigationMenu = [
//   {
//     name: 'User Management',
//     module_code:'UserMgmt',
//     routeName: 'User Management',
//     icon: UserIcon,
//     path: '/user-management',
//   },
//   {
//     name: 'Geo / Non Geo Entity',
//     module_code: "GeoNG_ZDC",
//     // module_code:'GeoNG_HBSD',
//     routeName: 'Geographical Entities',
//     icon: GeoNonGeoIcon,
//     path: '/zone',
//     // path: choosePathforTab(tabs[0]),
//   },
//   {
//     name: 'Geo / Non Geo Entity',
//     module_code: "GeoNG_HBSD",
//     // module_code:'GeoNG_HBSD',
//     routeName: 'Geographical Entities',
//     icon: GeoNonGeoIcon,
//     path: '/healthblock',
//   },
//   {
//     name: 'Health Facility',
//     module_code:'FcltyMgmt',
//     routeName: 'Health Facility',
//     icon: HealthFacilityIcon,
//     path: '/health-facility',
//   },
//   {
//     name: 'Notifications',
//     module_code:'Notifications',
//     routeName: 'Notifications',
//     icon: ApprovalIcon,
//     path: '/notifications',
//   },
//   {
//     name: 'Integrations',
//     module_code:'Integrations',
//     routeName: 'Integrations',
//     icon: ApprovalIcon,
//     path: '/integrations',
//   },
//   {
//     name: 'Beneficiaries',
//     module_code:'Benf',
//     routeName: 'Beneficiaries',
//     icon: beneficiaries,
//     path: '/beneficiaries',
//   }
// ];

const filteredNavigation = (nav:any) =>{

  const checkMapPath = MenuPermission(nav);
  // const unique = [...new Set(checkMapPath.map(item => item.routeName))];
  // const unique = Array.from(new Set(checkMapPath.map(item => item)));
  const arrayUniqueByKey = Array.from(new Map(checkMapPath.map(item => [item['name'], item])).values()); 
  // const setData = ([...new Set(checkMapPath)]);
  
  return arrayUniqueByKey;
}





  return (
    <div className="app-wrapper">
      <Navigation
        navigationMenu={filteredNavigation(navigationMenu(permissions))}
        setCurrentRoute={(currentRoute: string) => {
          setCurrentRoute(currentRoute);
        }

        }
        currentRoute={currentRoute}
      />
      <main className="app-content">
        <header className="app-header">
          {tabsData && tabsData.length > 0 && <BreadcrumbComponent breadcrumbItemName={breadcrumbOptions} />}
        </header>
        {props.page === 'User Management' && (
          <>{tabsData && tabsData.length > 0 && <UserTabs page={props.page} tabs={tabsData} tabState={tabsData[tabUserMgmtNumber(props?.showGeoTab)]} setTabKey={setTabState} />}</>
        )}
        {props.page === 'Health Facility' && (
          <FacilityTabs
            {...props}
            tabState={tabState}
            setTabKey={setTabState}
          />
        )}
        {props.page === 'Geographical Entities' && (
          <>{tabsData && tabsData.length > 0 && <TabsComponent page={props.page} tabs={tabsData} tabState={tabsData[tabNumber(props?.showGeoTab)]} setTabKey={setTabState} />}</>
        )}

        {props.page === 'Notifications' && <div></div>}
        {props.page === 'Integrations' && <div></div>}
        {props.page === 'References' && (
          <ReferencesTabs
            {...props}
            tabState={tabState}
            setTabKey={setTabState}
          />
        )}
        {/* {props.page === 'Beneficiaries' && (
          <BeneficiariesTabs
            {...props}
            tabState={tabState}
            setTabKey={setTabState}
          />
        )} */}
      </main>
    </div>
  );
};

export default AppWrapperComponent;